<template>
  <DBox
    :id="'cmp-catalog-labels-sidewindow-label_accounts'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('label_accounts')"
    @add_click="onLabelAccounts"
  >
    <Dropdown2
      :disabled="selectedLabelDetails.disabled"
      :label="$t('excluded_territory')"
      :placeholder="$t('excluded_territory')"
      deselect
      :options="selectedLabelDetails.territoriesTV"
      :selected="
        selectedLabelDetails.territoriesTV.find(
          e => e.value == selectedLabelDetails.label.territory_id
        )
      "
      v-on:selectedChange="e => onDropdownChange('territory_id', e)"
    />

    <div class="ut-fc ut-fh">
      <NTable
        class="dbox1"
        id="catalog-labels-sidewindow-label_accounts-list"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :showNoItems="false"
      >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('label_accounts')">
            <span class="txtov" :title="item['account_name']">
              {{ item["account_name"] }}
            </span>
          </td>
          <!-- <td v-bind="tdcon('shortname')">
            <span class="txtov" :title="item['short_name']">
              {{ item["short_name"] }}
            </span>
          </td> -->
          <td v-bind="tdcon('release_shift')">
            <TextField2
               class="dbox1"
              :id="'release_shift'"
              :ta="'right'"
              :showLabel="false"
              :value="item['release_shift']"
              @blur="e => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('exclude')">
            <div class="ut-rowcen">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="`exclude-${item['exclude']}`"
                  :id="`exclude-${item['label_account_id']}`"
                  :checked="item['exclude'] == '1'"
                  @click="e => onLabelSetupExclude(e, item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteLabelAccount(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>

    </div>


  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { EventHooks } from "../../../../plugins/text-field";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedLabelDetails"],
  data: function() {
    return {
      textFieldConfig: {
        height: 27,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      }
    };
  },
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    list: function() {
      return this.selectedLabelDetails.label_accounts || [];
    },
    headers: function() {
      return [
        createTableHeader("label_accounts", { mw: 135 }),
        // createTableHeader("shortname"),
        createTableHeader("release_shift"),
        createTableHeader("exclude", { ta: "center", mw: 70 }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    }
  },
  methods: {
    onLabelAccounts: function() {
      this.$emit("add_click", true);
    },

    onTextFieldValueChange: function({ name, value }, item) {
      // console.log("payload ", { name, value, item });
      this.$emit("changed", { name, value, item });
    },

    onDropdownChange: function(name, value) {
      // console.log("payload ", name, value);

      this.$emit("changedTerritory", {
        name,
        value: value.value ? value.value : ""
      });
    },

    onLabelSetupExclude: function(e, item) {
      if (e.target.checked) {
        this.$emit("changed", {
          name: "exclude",
          value: 1,
          item,
          label_id: this.selectedLabelDetails.label_id
        });
      } else {
        this.$emit("changed", {
          name: "exclude",
          value: 0,
          item,
          label_id: this.selectedLabelDetails.label_id
        });
      }
    },

    onDeleteLabelAccount: async function(item) {
      const confirmationResult = await confirmDelete(
        "Label Account",
        item.account_name
      );
      if (confirmationResult === "OK") {
        console.log("Delete");
        this.$emit("deleted", item);
      }
    }
  }
};
</script>

<style lang="scss">
.cmp-catalog-labels-sidewindow-label_accounts {
  .dropdown-2 {
    .txtov {
      height: 32px;
    }
  }
  .dropdown {
    max-width: 250px;
  }

  .dt-ntable {
    // --ntable-height: 158px !important;
   // margin-top: 10px;
  }
}
</style>
